import { Component, Input, OnInit } from '@angular/core';
import { AmbassadorsProfileService } from 'src/app/services/ambassadors-profile.service';
import { CvResumeFormComponent } from './cv-resume-form/cv-resume-form.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cv-resume',
  standalone: false,
  templateUrl: './cv-resume.component.html'
})
export class CvResumeComponent implements OnInit {
  @Input() userId!:any;
  @Input() canModify!:boolean;
  dataLoading = false
  dataSource: any

  constructor(
    private service: AmbassadorsProfileService,
    private dialog: MatDialog,
    private translate: TranslateService) {

  }


  ngOnInit(): void {
    this.getAll()
  }


  getAll() {
    this.dataLoading = true;
    const params = this.userId ? { userId: this.userId } : {};
    this.service.GetAmbassadorCvData(params).subscribe((response: any) => {
      this.dataLoading = false;
      if (response.name) {
        this.dataSource = response as any;
      }
    }, err => {
      this.dataLoading = false
    })
  }



  openForm(record: any = null) {
    const dialogRef = this.dialog.open(CvResumeFormComponent, {
      width: '550px',
      data: { record },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getAll();
      }
    });

  }

}
